import React from 'react';
import { AwsMap, Location, AwsMapConfig } from '@kyruus/aws-map';
import { DynamicGmap } from '@kyruus/gmap';

import { MapContainer, MapContainerInner } from './styles';

import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';
import { PMCConfig, ProviderMatchProviderLocationV9 } from '@kyruus/types';

interface MapProps {
  locations: ProviderMatchProviderLocationV9[];
  googleMapsUrl?: string;
  config: PMCConfig;
  awsMapConfig: AwsMapConfig;
  'data-testid'?: string;
}

const Map = ({
  locations,
  config,
  awsMapConfig,
  googleMapsUrl,
  'data-testid': dataTestId
}: MapProps): React.ReactElement | null => {
  return (
    <MapContainer
      data-testid={dataTestId}
      className="map-container"
      height={config.maps_config?.container_height}
    >
      <MapContainerInner>
        {config.maps_config?.location_service_provider !== 'aws' ? (
          <DynamicGmap
            url={googleMapsUrl || ''}
            locations={locations}
            enabledLocationIds={new Set(locations.map((loc) => loc.id))}
            mapOptions={{
              maxZoom: 16,
              fullscreenControl: false,
              mapTypeControl: false,
              streetViewControl: false,
              styles: [
                {
                  featureType: 'poi',
                  stylers: [{ visibility: 'off' }]
                }
              ]
            }}
          />
        ) : (
          <AwsMap
            awsMapConfig={awsMapConfig}
            locations={locations as Location[]}
          />
        )}
      </MapContainerInner>
    </MapContainer>
  );
};

export default withErrorBoundary(Map);
